import { render, staticRenderFns } from "./text-form.vue?vue&type=template&id=5f60986c&scoped=true"
import script from "./text-form.vue?vue&type=script&lang=ts"
export * from "./text-form.vue?vue&type=script&lang=ts"
import style0 from "./text-form.vue?vue&type=style&index=0&id=5f60986c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f60986c",
  null
  
)

export default component.exports